<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findCategoryVehicle"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :disabled="disabled"
            :readonly="readonly"
            :selected-multiple="dataMultiple"
            :multiple="multiple"
            :prop="prop"
            key-id="_id"
            key-label="name"
            @change="handleChange" />
    </div>
</template>

<script lang="ts" setup>
const store = $store()

const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  prop: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  dataMultiple: { type: [Array, Object], default: () => [] },
  required: { type: Boolean, default: false },
  name: { type: String || null, default: '' },
  query: { type: String, default: '' },
  label: { type: String, default: () => $t('labels.vehicleType') },
  assumptionDriver: { type: Boolean, default: false }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const { modelValue, name, required, multiple, query, assumptionDriver } = toRefs(props)

const company = store.system.getCompany
const findCategoryVehicle = async (s: string) => {
  const api = $url.utils.find.vehicleCategory

  const res = await $api(api, { query: { key: s, assumptionDriver: assumptionDriver.value || '', company: company._id || '' } })
  const resData: any = res?.data.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    emits('update:name', val)
  }
})
const information = ref([])

const handleChange = (val: any) => {
  information.value = val
}
</script>
